export default "__VITE_ASSET__DNC2wg4P__"